export default __webpack_public_path__ + "0f2fc5e0d8ab068d539fb9db17ea1867.svg";